(($) => {

  let heroTimeLine;

  // DOMContentLoadedで初期化
  document.addEventListener("DOMContentLoaded", (event) => {
    if (window.gsap && window.ScrollTrigger) {
      gsap.registerPlugin(ScrollTrigger);
    }
    initSmoothScroll();
    initMenu();
    initToTop();
    initAnimation();

    // loadはページ上の全リソースを待つため、無関係な外部リソースが詰まると
    // ヒーローが空白のまま止まる。上限時間を設けて必ず動き出すようにする
    setTimeout(startAnimation, 2000);
  }, {
    once: true
  });


  // loadイベントで初期化
  window.addEventListener("load", (event) => {
    // ScrollTriggerを使っている場合は必要に応じてrefresh
    if (window.ScrollTrigger) ScrollTrigger.refresh();
    startAnimation();
  }, {
    once: true
  });


  function initAnimation() {
    //fix loading="lazy"
    $("img[loading=lazy]").on("load", (event) => {
      if (window.ScrollTrigger) ScrollTrigger.refresh();
    });

    // トップページのヒーローアニメーション
    if (document.querySelector(".JML-page-top")) {
      const element = "#top .hero";
      const heroFgImg = "#top .hero .fg img";
      const heroBgImg = "#top .bg img";
      const heroScroll = "#top .hero .scroll";
      const heroScrollLine = "#top .hero .scroll .line";

      // GSAP未読込 / 動きを控える設定：CSSの初期値を解除して静止状態で表示する
      if (!window.gsap || RM.matches) {
        $(heroFgImg).css({ opacity: 1 });
        $(heroBgImg).css({ opacity: 1 });
        $(heroScroll).css({ opacity: 1 });
        $(heroScrollLine).css({ transform: "scaleY(1)" });
        return;
      }

      // スクロール誘導ライン：上から下へ伸び、下端へ吸い込まれるように消えてループ
      // 無限リピートなので導入アニメとは繋げず、表示が終わってから単独で回す
      const heroScrollLineTl = gsap.timeline({ repeat: -1, repeatDelay: 0.24, paused: true })
        // 上端を起点に伸びる
        .fromTo(heroScrollLine, {
          scaleY: 0,
          transformOrigin: "center top",
        }, {
          scaleY: 1,
          duration: 0.96,
          ease: "power2.inOut",
        })
        // scaleY(1)の間に起点を下端へ切り替える（等倍なので見た目は変化しない）
        .set(heroScrollLine, {
          transformOrigin: "center bottom",
        }, "+=0.24")
        // 上端が下へ追いつく形で消える
        .to(heroScrollLine, {
          scaleY: 0,
          duration: 0.96,
          ease: "power2.inOut",
        });

      heroTimeLine = gsap.timeline({ paused: true })
        // 背景は前景よりゆっくり収束させて奥行きを出す（同じ値だと1枚の平面に見える）
        .fromTo(heroBgImg, {
          scale: 1.3,
          autoAlpha: 0,
        }, {
          scale: 1,
          autoAlpha: 1,
          duration: 2.6,
          ease: "expo.out",
        })
        .fromTo(heroFgImg, {
          scale: 0,
          xPercent: -10,
          yPercent: 10,
          autoAlpha: 0,
        }, {
          scale: 1,
          xPercent: 0,
          yPercent: 0,
          autoAlpha: 1,
          duration: 2,
          ease: "expo.out",
        }, "<")
        // 前景の開始から1.5秒後（背景のdurationを変えても位置がずれないよう "<" 基準）
        .to(heroScroll, {
          autoAlpha: 1,
          duration: 1,
        }, "<1.5")
        // 表示が完了してからループ開始（回しっぱなしだと出現時に線が消える途中になる）
        .add(() => heroScrollLineTl.play());
    }
  }

  function startAnimation() {
    heroTimeLine?.play();
  }


  // メニューの開閉
  function initMenu() {
    const $button = $("#JML-menu-button");
    const $menu = $("#JML-menu");
    const $body = $("#JML-body");
    if (!$button.length || !$menu.length) return;

    const isOpen = () => $button.attr("aria-expanded") === "true";

    function open() {
      if (isOpen()) return;

      $button.attr("aria-expanded", "true");
      $menu.attr("aria-hidden", "false");
      $body.addClass("-menu_open");
    }

    function close() {
      if (!isOpen()) return;

      $button.attr("aria-expanded", "false");
      $menu.attr("aria-hidden", "true");
      $body.removeClass("-menu_open");
    }

    $button.on("click", () => { isOpen() ? close() : open(); });

    // Escで閉じる
    $(document).on("keydown", (event) => {
      if (event.key === "Escape" && isOpen()) close();
    });

    // メニュー内のリンク：スムーススクロールより先に閉じてスクロール位置を戻す
    // （#JML-menu で拾うので、documentに委譲しているスムスクより先に動く）
    $menu.on("click", 'a[href*="#"]', () => { close(); });

    //open(); // 初期状態で開く場合はここで呼ぶ
  }


  // トップへ戻るボタン：1画面分スクロールしたら表示する
  function initToTop() {
    const target = "#JML-to_top";
    if (!$(target).length) return;

    // GSAP未読込：CSS通り常時表示のままにする（隠れっぱなしを避ける）
    if (!window.gsap || !window.ScrollTrigger) return;

    // トップページはヒーローを抜けた時点、それ以外は1画面分スクロールした時点
    const hero = document.querySelector("#top");
    const config = hero
      ? { trigger: hero, start: "bottom top" }
      : { trigger: document.body, start: "top+=100% top" };

    const duration = RM.matches ? 0 : 0.3;

    const st = ScrollTrigger.create({
      ...config,
      end: "max",
      onToggle: (self) => {
        gsap.to(target, { autoAlpha: self.isActive ? 1 : 0, duration, overwrite: true });
      },
    });

    // 途中までスクロールされた状態で読み込まれた場合に備え、初期状態を合わせる
    gsap.set(target, { autoAlpha: st.isActive ? 1 : 0 });
  }


  // 設定とユーティリティ
  const RM = window.matchMedia?.("(prefers-reduced-motion: reduce)") || { matches: false };
  const PC_BP = window.VIEWPORT_CONFIG?.PC_BREAKPOINT ?? 768; // フォールバック
  const PC_MQ = window.matchMedia?.(`(min-width: ${PC_BP}px)`) || { matches: true };

  function isPC() { return !!PC_MQ.matches; }
  function isMobile() { return !PC_MQ.matches; }

  // 汎用デバウンス
  function debounce(fn, wait = 150) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(null, args), wait);
    };
  }

  // initSmoothScroll
  function initSmoothScroll(defaultOffset = 0) {
    $(document).on("click", 'a[href*="#"]:not(.-no_smooth_scroll)', (event) => {
      // a要素取得
      const $a = $(event.currentTarget);

      // ユーザーの意図を尊重（修飾キー、別タブ）
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if ($a.attr("target") === "_blank") return;

      // href と URL解析
      const href = $a.attr("href");
      if (!href) return;
      const url = new URL(href, location.href);

      // オリジン/パスチェック（同一ページのみスムスク）
      if (url.origin !== location.origin) return;

      const currentPath = normalizePath(location.pathname);
      const targetPath = normalizePath(url.pathname);
      if (currentPath !== targetPath) return;

      // スムスク対象のIDを決定
      const id = url.hash;
      const target = id && id !== "#" ? id : document.documentElement;

      // 個別オフセット（data-offset）優先
      const linkOffset = Number($a.data("offset"));
      const offset = Number.isFinite(linkOffset) ? linkOffset : defaultOffset;

      // デフォルト動作を止めてスムスク/ジャンプ
      event.preventDefault();

      if (RM.matches) {
        // 動きを控えるユーザー設定：即時移動
        jumpTo(target, offset);
      } else {
        smoothScrollTo(target, offset);
      }
    });
  }

  // ジャンプ移動（A11y対応）
  function jumpTo(target, offset = 0) {
    const $target = $(target);
    if (!$target.length) return;
    const y = $target.offset().top - offset;
    window.scrollTo(0, y);
    focusTarget($target);
  }

  // スムーススクロール（A11y対応）
  function smoothScrollTo(target, offset = 0) {
    const $target = $(target);
    if (!$target.length) return;

    const start = $target.offset().top - offset;
    moveTo(start, 500);

    function moveTo(position, duration) {
      $.when(
        $("html, body").stop().animate({ scrollTop: position }, duration, "swing")
      ).done(() => {
        const newPos = $target.offset().top - offset;
        if (Math.abs(newPos - position) > 1) {
          moveTo(newPos, Math.max(duration - 100, 100));
        } else {
          focusTarget($target); // 最終到達時にフォーカス
        }
      });
    }
  }

  // フォーカス移動の補助（スクリーンリーダー配慮）
  function focusTarget($el) {
    const el = $el.get(0);
    if (!el) return;
    const hadTabindex = el.hasAttribute("tabindex");
    if (!hadTabindex) el.setAttribute("tabindex", "-1");
    el.focus({ preventScroll: true });
    if (!hadTabindex) el.addEventListener("blur", () => el.removeAttribute("tabindex"), { once: true });
  }

  // 正規表現のキャッシュ
  const normalizePathRegex =
    /\/index\.(html|php|htm|asp|aspx|cgi|pl|jsp|cfm|shtml)$/;

  // indexファイルをルート `/` に統一 + 末尾スラッシュの正規化
  function normalizePath(path) {
    return path
      .replace(normalizePathRegex, "/")
      .replace(/\/+$/, "")
      .replace(/^\/?/, "/");
  }

})(jQuery);
